"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.MIN_WIDTH_VALUE = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _aphrodite = require("aphrodite");

var _mobxReact = require("mobx-react");

var _reactRouterDom = require("react-router-dom");

var _Popover = _interopRequireDefault(require("../Popover"));

var _StaggeredScaleIn = _interopRequireDefault(require("../effect/animation/StaggeredScaleIn"));

var _LoadingIndicator = _interopRequireDefault(require("../effect/LoadingIndicator"));

var _providers = require("../../toolkit/providers");

var _styling = require("../../toolkit/styling");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var MIN_WIDTH_VALUE = 154;
/* eslint-disable local-rules/unwrapped-i18n */

exports.MIN_WIDTH_VALUE = MIN_WIDTH_VALUE;
var propDoc = {
  onClick: {
    required: false,
    defaultValue: "null",
    type: "?() => void",
    description: "Optional callback for button click"
  },
  isDisabled: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Indicates if the button is disabled. " + "Set this to true while making API call."
  },
  isReactRouterLink: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "If the button is being used as a link, use this value to " + "indicate if it is an internally handled link. Internal links " + "are handled by JS and do not refresh the page"
  },
  href: {
    required: false,
    defaultValue: "null",
    type: "(string | null)",
    description: "If button is a link, set this to the `href` value"
  },
  isLoading: {
    required: false,
    defaultValue: "false",
    type: "boolean",
    description: "Set to true while the button's action is happening"
  },
  popoverContent: {
    required: false,
    defaultValue: "null",
    type: "(string | null) | ((() => ReactNode))",
    description: "Set if the button displays a popover when hovered. Value is the " + "popover's content: either string or a custom render function "
  },
  popoverPosition: {
    required: false,
    defaultValue: "top center",
    type: "(string | null)",
    description: "Position of the button's popover -- if it has one"
  },
  popoverStyle: {
    required: false,
    defaultValue: "null",
    type: "?any",
    description: "Style of the button's popover container - height style (i.e. flex) goes here"
  },
  minWidth: {
    required: false,
    defaultValue: "false",
    type: "?boolean",
    description: "Controls whether the button has a default min width, currently ".concat(MIN_WIDTH_VALUE)
  }
};
var demoRender = "\n<PrimaryButton onClick={() => null} popoverContent=\"Describe what I do\">\n  Click me\n</PrimaryButton>\n";
var demoProps = {};
var PrimaryButton = (0, _mobxReact.observer)(function (props) {
  var classNameProp = props.className,
      style = props.style,
      children = props.children,
      href = props.href,
      onClick = props.onClick,
      _props$isLoading = props.isLoading,
      isLoadingProp = _props$isLoading === void 0 ? false : _props$isLoading,
      _props$isDisabled = props.isDisabled,
      isDisabled = _props$isDisabled === void 0 ? false : _props$isDisabled,
      _props$openInNewTab = props.openInNewTab,
      openInNewTab = _props$openInNewTab === void 0 ? false : _props$openInNewTab,
      _props$isReactRouterL = props.isReactRouterLink,
      isReactRouterLink = _props$isReactRouterL === void 0 ? false : _props$isReactRouterL,
      minWidth = props.minWidth;

  var _useTheming = (0, _providers.useTheming)(),
      textWhite = _useTheming.theme.textWhite;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isWaitingOnClick = _useState2[0],
      setIsWaitingOnClick = _useState2[1];

  var navigator = (0, _providers.useLegoNavigator)();
  var isLoading = isLoadingProp || isWaitingOnClick;
  var handleClick = (0, _react.useCallback)( /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(e) {
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!(isLoading || isDisabled)) {
                _context.next = 2;
                break;
              }

              return _context.abrupt("return");

            case 2:
              setIsWaitingOnClick(true);
              e.preventDefault();

              if (!href) {
                _context.next = 7;
                break;
              }

              _context.next = 7;
              return navigator.navigate(href, {
                openInNewTab: openInNewTab
              });

            case 7:
              if (!onClick) {
                _context.next = 10;
                break;
              }

              _context.next = 10;
              return onClick(e);

            case 10:
              setIsWaitingOnClick(false);

            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [onClick, isLoading, isDisabled, href, openInNewTab, navigator]);
  var styles = useStylesheet({
    isLoading: isLoading,
    minWidth: minWidth
  });

  var content = /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, isLoading && /*#__PURE__*/_react["default"].createElement(_StaggeredScaleIn["default"], {
    animationDurationMs: 400
  }, /*#__PURE__*/_react["default"].createElement(_LoadingIndicator["default"], {
    className: (0, _styling.css)(styles.loading),
    type: "spinner",
    size: 16,
    color: textWhite
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _styling.css)(styles.textContainer)
  }, children));

  var buttonProps = {
    onClick: handleClick,
    className: (0, _styling.css)(styles.root, isDisabled ? styles.rootDisabled : styles.rootEnabled, classNameProp, style)
  };

  if (href != null) {
    var anchorProps = _objectSpread(_objectSpread({}, buttonProps), {}, {
      href: isDisabled ? undefined : href || undefined
    });

    if (isReactRouterLink) {
      return /*#__PURE__*/_react["default"].createElement(_reactRouterDom.Link, (0, _extends2["default"])({}, buttonProps, {
        to: href
      }), content);
    }

    return /*#__PURE__*/_react["default"].createElement("a", (0, _extends2["default"])({}, anchorProps, {
      rel: openInNewTab ? "noopener noreferrer" : undefined,
      target: openInNewTab ? "_blank" : undefined
    }), content);
  }

  return /*#__PURE__*/_react["default"].createElement("div", buttonProps, content);
});

var PrimaryButtonWrapper = function PrimaryButtonWrapper(props) {
  var popoverPosition = props.popoverPosition,
      popoverContent = props.popoverContent,
      popoverStyle = props.popoverStyle;
  return /*#__PURE__*/_react["default"].createElement(_Popover["default"], {
    position: popoverPosition || "top center",
    popoverMaxWidth: 250,
    popoverContent: popoverContent,
    className: popoverStyle
  }, /*#__PURE__*/_react["default"].createElement(PrimaryButton, props));
};

PrimaryButtonWrapper.propDoc = propDoc;
PrimaryButtonWrapper.demoProps = demoProps;
PrimaryButtonWrapper.demoRender = demoRender;

var _default = (0, _mobxReact.observer)(PrimaryButtonWrapper);

exports["default"] = _default;

var useStylesheet = function useStylesheet(_ref2) {
  var isLoading = _ref2.isLoading,
      minWidth = _ref2.minWidth;

  var _useTheming2 = (0, _providers.useTheming)(),
      _useTheming2$theme = _useTheming2.theme,
      textWhite = _useTheming2$theme.textWhite,
      primary = _useTheming2$theme.primary,
      primaryDark = _useTheming2$theme.primaryDark,
      fonts = _useTheming2.fonts;

  return (0, _react.useMemo)(function () {
    return _aphrodite.StyleSheet.create({
      root: {
        // prop is controlled by parent
        // eslint-disable-next-line local-rules/validate-root
        minWidth: !!minWidth ? MIN_WIDTH_VALUE - 52 : undefined,
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "center",
        borderRadius: 4,
        transition: "all 0.2s linear",
        transitionProperty: "opacity, background-color, border-color",
        textOverflow: "ellipsis",
        whiteSpace: "nowrap",
        overflow: "hidden",
        textRendering: "optimizeSpeed",
        userSelect: "none",
        fontFamily: fonts.semibold,
        "@media (min-width: 900px)": {
          padding: "5px 25px"
        },
        "@media (max-width: 900px)": {
          padding: "7px 15px"
        }
      },
      textContainer: {
        display: "inline-block"
      },
      rootEnabled: {
        cursor: isLoading ? "default" : "pointer",
        color: textWhite,
        backgroundColor: isLoading ? primaryDark : primary,
        border: "1px solid ".concat(isLoading ? primaryDark : primary),
        ":active": !isLoading ? {
          backgroundColor: primaryDark,
          border: "1px solid ".concat(primaryDark)
        } : {}
      },
      rootDisabled: {
        cursor: "default",
        backgroundColor: primary,
        color: textWhite,
        opacity: 0.6,
        border: "1px solid ".concat(primary)
      },
      loading: {
        marginRight: 10
      }
    });
  }, [isLoading, textWhite, primary, primaryDark, minWidth, fonts.semibold]);
};